export default __webpack_public_path__ + "static/media/kiwisupercocktail@3x.da4a44b5.jpg";